'use strict';

import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';

export async function loadCreateNewPin() {
    $('body').on('click', '[data-action="archiveNoDataNewPin"]', function(event) {
        event.stopPropagation();
        const action = $(this).data('action');
        if (action === 'archiveNoDataNewPin') {
            ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: action
                },
                success : function( data ) {
                    ResponseDispatcher.handle(data);
                },
                dataType : 'json'
            });
        }
    });
    $('body').on('click', '[data-action="back"]', function(event) {
        event.stopPropagation();
        history.back();
    });
}